/**
 * Phase 20E — Centrale frontend adresopmaak (NAW).
 *
 * Mirror van /app/backend/address_helpers.py. Wordt gebruikt door
 * NewQuoteDialog, OfferteDetail klant-tab en eventuele inline preview-blokken.
 */

function clean(v) {
  if (v === null || v === undefined) return "";
  const s = String(v).trim();
  const lower = s.toLowerCase();
  if (["none", "null", "undefined", "nan"].includes(lower)) return "";
  return s;
}

function hasStructuredAddress(data) {
  if (!data) return false;
  return ["street", "house_number", "postal_code", "city"].some(
    (k) => clean(data[k]),
  );
}

function streetLine(data) {
  const street = clean(data.street);
  const nr = clean(data.house_number);
  const add = clean(data.house_number_addition);
  if (!street && !nr) return "";
  const parts = [];
  if (street) parts.push(street);
  if (nr) {
    const nrFull = add && (add.startsWith("-") || add.startsWith("/"))
      ? nr + add
      : (add ? `${nr} ${add}` : nr);
    parts.push(nrFull.trim());
  }
  return parts.join(" ").trim();
}

function cityLine(data) {
  const pc = clean(data.postal_code);
  const city = clean(data.city);
  if (pc && city) return `${pc} ${city}`;
  return pc || city || "";
}

/**
 * Build meerregelig adresblok.
 * @param {object} data — quote/invoice payload
 * @param {object} opts — { includeContact: bool, legacyAddress: string }
 * @returns {string[]} non-empty lines
 */
export function formatAddressLines(data, opts = {}) {
  const { includeContact = true, legacyAddress = null } = opts;
  const lines = [];
  if (!data) return lines;

  const company = clean(data.company_name);
  if (company) lines.push(company);

  if (hasStructuredAddress(data)) {
    const sl = streetLine(data);
    if (sl) lines.push(sl);
    const cl = cityLine(data);
    if (cl) lines.push(cl);
    const country = clean(data.country);
    if (country) lines.push(country);
  } else {
    const legacy = clean(legacyAddress) || clean(data.pickup_address) || clean(data.address);
    if (legacy) {
      const parts = legacy.replace(/\n/g, ",").split(",").map((p) => p.trim()).filter(Boolean);
      lines.push(...parts);
    }
  }

  if (includeContact) {
    const email = clean(data.email) || clean(data.customer_email);
    if (email) lines.push(email);
    const phone = clean(data.phone) || clean(data.customer_phone);
    if (phone) lines.push(phone);
  }
  return lines;
}

/**
 * @returns {string[]} lijst van labels van ontbrekende verplichte adresvelden
 */
export function addressMissingFields(data) {
  const labels = {
    street: "Straatnaam",
    house_number: "Huisnummer",
    city: "Stad",
    country: "Land",
  };
  if (!data) return Object.values(labels);
  return Object.entries(labels)
    .filter(([k]) => !clean(data[k]))
    .map(([, label]) => label);
}

export function isAddressComplete(data) {
  return addressMissingFields(data).length === 0;
}
